import React, { useState, useRef, useEffect } from 'react'
import { post } from '../../utils/apiClient'
import { Input, Icon, Loader } from 'semantic-ui-react'
import { useMessage } from '../../entities'

export default function ConfirmUser({ userToConfirm }) {
  const [, { updateMessage }] = useMessage()
  let refCodeInput = useRef()
  const [state, setState] = useState({
    confirm_uid: null,
    form_message: '',
    is_loading: false
  })

  const mount = () => {
    async function fetchData() {}
    fetchData()
    return () => post.completeRequest(false)
  }
  useEffect(mount, [])

  const sendVerification = async () => {
    if (state.is_loading) return
    setState({ ...state, is_loading: true, form_message: '' })
    let res = await post('/api/account/verify/email-request', {
      data: { email: userToConfirm.email }
    })
    if (res.ok) {
      setState({ ...state, confirm_uid: res.confirm, is_loading: false })
      if (res.message) updateMessage({ message: <p>{res.message}</p> })
      refCodeInput.current.focus()
    } else if (res) {
      setState({
        ...state,
        is_loading: false,
        form_message: 'Please provide the verification code.'
      })
    }
  }

  const confirmCode = async () => {
    if (state.is_loading) return
    setState({ ...state, is_loading: true, form_message: '' })
    let confirmed_code = refCodeInput.current.value.trim()
    if (!confirmed_code)
      return setState({
        ...state,
        is_loading: false,
        form_message: 'Please provide the verification code.'
      })

    let res = await post('/api/account/verify/email-confirm', {
      data: {
        email: userToConfirm.email,
        code: confirmed_code,
        confirm: state.confirm_uid
      }
    })
    if (res.ok) {
      setState({ ...state, is_loading: false, confirm_uid: true })
      if (res.message) updateMessage({ message: <p>{res.message}</p> })
    } else if (res) {
      setState({
        ...state,
        is_loading: false,
        form_message: 'Please provide the verification code.'
      })
    }
  } // end confirmCode

  if (state.confirm_uid === true) return ''
  return (
    <div className="fs-smaller">
      Confirm email
      {state.confirm_uid ? (
        <>
          <Input
            loading={state.is_loading}
            ref={refCodeInput}
            icon={
              <Icon
                onClick={() => confirmCode()}
                className="gogreen"
                name="check"
                inverted
                link
              />
            }
            placeholder="verify code"
          />
          {state.form_message && (
            <div className="cf-error">{state.form_message}</div>
          )}
        </>
      ) : (
        <>
          <span className="alink" onClick={() => sendVerification()}>
            {state.is_loading && <Loader size="mini" active inline />} Send
            verification email
          </span>
        </>
      )}
    </div>
  )
}
